<template>
  <div>
    <button type="button" class="btn-sm btn-blue m-1" @click="addShowClicked"><span class='text-xl leading-none'>+</span> Add Show Template</button>

    <b-modal size="xl" ref="showModal" title="Add Show From Template" no-close-on-backdrop>
      <div id="chooseTemplate" class="rounded md:border">
        <div class="flex  justify-between items-center p-3 bg-gray-200 rounded-t">
          <h3 class="text-2xl">Template</h3>
          <div class="flex items-center space-x-1">
            <label>Use Existing Entry Type: </label>
            <input v-model="useExistingEntryType" type="checkbox" @change="selectedTemplate = null">
          </div>
        </div>
        <div class="py-4 w-full">
          <div v-if="useExistingEntryType">
            <label>Choose Entry Type:</label>
            <v-select
              class="rounded mt-1 p-1"
              v-model="selectedEntryType"
              :options="eventShowTypes"
              :reduce="option => option"
              label="label"
              :clearable="false"
              @input="entryTypeSelected"
            >
              <template slot="option" slot-scope="option">
                {{option.group_type}} ~ {{ option.label }}
              </template>
            </v-select>
          </div>
          <div v-else>
            <div class="flex flex-col md:flex-row justify-between w-full">
              <div class="md:w-1/2 md:px-3">
                <label>Species:</label>
                <v-select
                  class="rounded mt-1"
                  v-model="show.species"
                  :options="speciesOptions"
                  :reduce="option => option"
                  :clearable="false"
                  @input="inputSelected"
                >
                </v-select>
              </div>
              <div class="md:w-1/2 md:px-3">
                <label>Template:</label>
                <v-select
                  class="rounded mt-1"
                  v-model="selectedTemplate"
                  :options="filteredClassConfigTemplates"
                  :reduce="option => option"
                  label="show_template_identifier"
                  :clearable="false"
                  @input="templateSelected"
                  :disabled="!show.species"
                >
                  <template slot="option" slot-scope="option">
                    {{option.group}} ~ {{ option.show_template_identifier }}
                  </template>
                </v-select>
                <div class="text-center" v-if="!show.species">
                  Please choose a species first in order to choose from available templates.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="show_details" class="md:border rounded mt-6" v-if="selectedTemplate || (useExistingEntryType)" >
        <div class="flex flex-col md:flex-row md:justify-between md:items-center p-3 bg-gray-200 rounded-t">
          <div>
            <h3 class="text-2xl">Shows</h3>
          </div>
          <div class="flex justify-end items-center space-x-3">
            <input class="p-2 text-sm border w-64 rounded-md" v-model="showName" placeholder="Show Name" @keyup.enter="addShowName">
            <button class="btn-sm btn-green text-xs" @click="addShowName">+ Add Show</button>
          </div>
        </div>
        <div class="flex flex-col-reverse md:flex-row justify-between">
          <div class="md:w-1/2 mt-2 md:mt-0 md:p-3 md:border-r">
            <template v-if="selectedTemplate">
              <div class="">
                <p class="text-lg font-bold mb-1">Entry Type Details</p>
                <div class="mb-1">
                  <label for="label" class="block text-sm font-medium leading-6 text-gray-900">Label</label>
                  <div class="mt-1">
                    <input v-model="selectedTemplate.label" type="label" name="label" id="label" class="block w-full rounded-md px-2 py-1.5 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="" aria-describedby="label-description">
                  </div>
                  <p class="mt-1 text-sm text-gray-600" id="label-description">The label exhibitors will see in the "New Entry" dropdown when entering this show.</p>
                </div>
                <div class="mb-1">
                  <label for="group" class="block text-sm font-medium leading-6 text-gray-900">Group</label>
                  <div class="mt-1">
                    <input v-model="selectedTemplate.group" type="group" name="group" id="group" class="block w-full rounded-md px-2 py-1.5 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="" aria-describedby="group-description">
                  </div>
                  <p class="mt-1 text-sm text-gray-600" id="group-description">How entries in this show will be grouped</p>
                </div>
              </div>
            </template>
            <template v-if="selectedEntryType && useExistingEntryType">
              <div class="">
                <p class="text-lg font-bold mb-1">Show Details</p>
                <div class="mb-1">
                  <label for="label" class="block text-sm font-medium leading-6 text-gray-900">Type</label>
                  <div class="mt-1">
                    <input v-model="selectedEntryType.type" type="text" name="label" id="label" class="block w-full rounded-md px-2 py-1.5 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" aria-describedby="label-description">
                  </div>
                </div>
                <div class="mb-1">
                  <label for="group" class="block text-sm font-medium leading-6 text-gray-900">Species</label>
                  <div class="mt-1">
                    <v-select
                      class="rounded mt-1"
                      v-model="selectedEntryType.species"
                      :options="speciesOptions"
                      :reduce="option => option"
                      :clearable="false"
                    >
                </v-select>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="md:w-1/2 md:p-3">
            <div id="showName">
              <div class="">
                <div v-if="!showNames.length" class="text-center">
                  <p class="text-xl font-bold mb-1">No Shows Names Added</p>
                  <p class="text-sm text-gray-700">Type the name of the show you would like to add in the input above. If you have multiple rings/shows of the same type you can add multiple shows in at once.</p>
                </div>
                <div v-else >
                  <p class="text-2xl font-bold mb-1">Shows to add:</p>
                  <div v-for="(s, i) in showNames" :key="i" class="flex justify-between items-center text-base mb-0.5 py-1">
                    <input type="text" v-model="s.name" class="px-2 py-2 text-sm font-semibold border border-gray-300 w-64 rounded-md">
                    <div class="flex space-x-2 items-center">
                      <v-select
                        class="rounded-md mt-1 w-40 text-sm"
                        v-model="s.species"
                        :options="speciesOptions"
                        :reduce="option => option"
                        :clearable="false"
                        @input="inputSelected"
                      >
                      </v-select>
                      <button class="px-1.5 py-0.5 bg-red-500 hover:bg-red-700 text-white rounded-full text-xs" @click="showNames.splice(i, 1)">Remove</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="class_list" class="md:border rounded mt-6" v-if="showNames.length && selectedTemplate" >
        <div class="flex justify-between items-center p-3 bg-gray-200 rounded-t">
          <div>
            <h3 class="text-2xl">Class List</h3>
            <div class="flex justify-end items-center space-x-1">
              <p class="text-sm">Use Existing Class List:</p>
              <input v-model="useExistingClassList" type="checkbox" @change="selectedClassList = null">
            </div>
          </div>
          <div class="flex justify-end ">
            <div class="px-3" v-if="!useExistingClassList">
              <p class="mt-1 text-base font-medium" id="cl_id-description">Internal Class List ID</p>
              <div class="w-64">
                <input v-model="selectedTemplate.show_template_identifier" type="text" name="cl_id" id="cl_id" class="block w-full rounded-md px-2 py-1.5 text-gray-900 shadow-sm border border-gray-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm sm:leading-6" placeholder="" aria-describedby="cl_id-description">
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col justify-between" >
          <div class="md:p-3" >
            <div class="" v-if="selectedTemplate">
              <template v-if="useExistingClassList">
                <label>Choose Class List:</label>
                <v-select
                  class="rounded mt-1 p-1"
                  v-model="selectedClassList"
                  :options="classLists"
                  :reduce="option => option"
                  label="identifier"
                  :clearable="false"
                >
                  <template slot="option" slot-scope="option">
                    {{option.identifier}}
                  </template>
                </v-select>
              </template>
              <template v-else>
                <SimpleClassListConfig :selectedTemplate="selectedTemplate" :breeds="speciesData.breeds" :baseConfig="selectedTemplate.config"/>
              </template>
            </div>
          </div>
        </div>
      </div>
      <preview-class-list v-if="selectedTemplate" class="mt-2" :config="selectedTemplate.config" />

      <div slot="modal-footer" class="w-full">
        <div class="flex justify-end space-x-2">
          <button v-if="showNames.length && (selectedTemplate || selectedEntryType) && (!useExistingClassList || selectedClassList)" class="btn-blue btn-sm" variant="primary" @click="addShows()">
            Add Shows
          </button>
          <button class="btn-gray-outline btn-sm" variant="primary" @click="$refs.showModal.hide()">
            Close
          </button>
        </div>
      </div>
    </b-modal>
  </div>

</template>

<script>
/* import FormGenerator from '@/components/FormGenerator.vue'
import VJsoneditor from 'v-jsoneditor'
import ShowmanTypeAhead from '@/components/ShowmanTypeAhead.vue'
import DivisionConfig from '@/components/admin/classListConfig/DivisionConfig.vue'
import PreviewClassList from '@/components/admin/classListConfig/PreviewClassList.vue' */
import PreviewClassList from '@/components/admin/classListConfig/PreviewClassList.vue'
import SimpleClassListConfig from '@/components/admin/classListConfig/SimpleClassListConfig.vue'
import Vue from 'vue'

export default {
  props: {
    event: Object
  },
  components: {
    SimpleClassListConfig,
    PreviewClassList
  },
  data () {
    return {
      show: {},
      showName: '',
      showNames: [],
      classConfigurationTemplates: [],
      speciesData: {},
      speciesOptions: [
        'GOATS',
        'SHEEP',
        'SWINE',
        'CATTLE',
        'DAIRY CATTLE',
        'DAIRY GOATS',
        'RABBITS',
        'POULTRY',
        'HORSES',
        'OTHER',
        'EXHIBITOR'
      ],
      selectedTemplate: null,
      currentEntryType: null,
      useExistingClassList: false,
      useExistingEntryType: false,
      selectedEntryType: null,
      selectedClassList: null
    }
  },
  methods: {
    addShowName () {
      if (this.showName) {
        this.showNames.push({
          name: this.showName,
          species: this.useExistingEntryType ? this.selectedEntryType.species : this.show.species
        })
        this.showName = ''
      }
    },
    addShowClicked () {
      this.show = {
        show_settings: {}
      }
      this.selectedTemplate = null
      this.showNames = []
      this.$refs.showModal.show()
    },
    addShowNew: function () {
      this.show.event_id = this.event.event_id
      this.show.admin_id = this.event.admin_id
      this.show.created_by = this.currentUser.user_id
      this.$store.dispatch('addShowDynamic', {classConfig: this.classListConfig, show: this.show, entryType: this.entryType})
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Show Added`
          })
        })
        .catch(() => {
          // // console.log(error)
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error Adding SHow, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    addShows () {
      let shows = []
      let entryType = {}
      let classConfig = {}

      if (this.selectedTemplate) {
        entryType = {
          label: this.selectedTemplate.label,
          identifier: this.selectedTemplate.show_template_identifier,
          group_type: this.selectedTemplate.group,
          entry_details: this.selectedTemplate.entry_details,
          sub_entry_details: this.selectedTemplate.sub_entry_details,
          class_calc: this.selectedTemplate.class_calc
        }
      }

      if (this.useExistingClassList) {
        classConfig = this.selectedClassList
      } else {
        if (this.selectedTemplate) {
          classConfig = {
            config: this.selectedTemplate.config,
            identifier: this.selectedTemplate.show_template_identifier
          }
        }
      }

      this.showNames.forEach((s, i) => {
        shows.push({
          name: s.name,
          event_id: this.event.event_id,
          admin_id: this.event.admin_id,
          created_by: this.currentUser.user_id,
          type: this.useExistingEntryType ? this.selectedEntryType.type : this.selectedTemplate.show_type,
          species: this.useExistingEntryType ? this.selectedEntryType.species : s.species,
          entry_details_id: this.useExistingEntryType ? this.selectedEntryType.event_show_type_id : null
        })
      })

      this.$store.dispatch('addShowDynamicTemplate', {classConfig: classConfig, shows: shows, entryType: entryType})
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Shows Added`
          })
          this.showNames = []
          this.selectedTemplate = null
          this.$refs.showModal.hide()
        })
        .catch(() => {
          // // console.log(error)
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error Adding Shows, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    generateClassList () {
      this.axios.post(`${process.env.VUE_APP_ROOT_API}/generateClassList`, {config: this.classListConfig.config})
        .then(response => {
          this.classListPreview = response.data.data
        })
    },
    previewEntryType () {
      this.$store.dispatch('previewEntryType', {entry_type: this.entryType, classConfig: this.classListConfig, dynamic: true})
        .then(response => {
          this.entryTypePreview = response
          // // console.log(response)
          this.notie.alert({
            type: 1,
            text: `Entry TYpe Successfully Generated`
          })
        })
        .catch(() => {
          // // console.log(error)
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error generating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    setJudge (judge) {
      this.show.judge = judge
    },
    resetClassConfig () {
      this.classListConfig = {
        identifier: '',
        config: {}
      }
    },
    setTemplate (template) {
      this.classListConfig.config = template
    },
    templateSelected (template) {
      this.selectedTemplate = JSON.parse(JSON.stringify(template))
      if (!this.selectedTemplate.config.divisions) {
        Vue.set(this.selectedTemplate.config, 'divisions', [])
      } else {
        this.selectedTemplate.config.divisions.forEach(d => {
          if (!d.classes) {
            Vue.set(d, 'classes', [])
          }
          if (!d.divisions) {
            Vue.set(d, 'divisions', [])
          }
        })
      }
      if (!this.selectedTemplate.config.classes) {
        Vue.set(this.selectedTemplate.config, 'classes', [])
      }
      if (!this.selectedTemplate.config.division_champion_title) {
        if (this.selectedTemplate.config.divisions[0]) {
          Vue.set(this.selectedTemplate.config, 'division_champion_title', this.selectedTemplate.config.divisions[0].champion_title)
        } else {
          Vue.set(this.selectedTemplate.config, 'division_champion_title', 'Champion')
        }
      }
    },
    entryTypeSelected () {
      if (this.eventShowTypeShows[0]) {
        this.selectedEntryType.species = this.eventShowTypeShows[0].species
        this.selectedEntryType.type = this.eventShowTypeShows[0].type
      }
    },
    inputSelected () {
      this.$store.state.apiInstance.get(`/getSpeciesTypeData/${this.show.species}`)
        .then(response => {
          this.speciesData = response.data.data
          if (!this.speciesData) {
            this.speciesData = {
              breeds: []
            }
          }
        })
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    currentUser () {
      return this.$store.state.user
    },
    eventShowTypes () {
      return this.adminData.event_show_types
    },
    classLists () {
      return this.adminData.class_configurations
    },
    filteredClassConfigTemplates () {
      return this.classConfigurationTemplates.filter(template => {
        return template.species === this.show.species
      })
    },
    eventShowTypeShows () {
      if (this.selectedEntryType) {
        return this.adminData.event.shows.filter(s => this.selectedEntryType.event_show_type_id === s.entry_details_id)
      }
      return []
    }
  },
  mounted () {
    this.$store.state.apiInstance.get(`/callFunction/getEventTemplates?eventID=${this.event.event_id}`)
      .then(response => {
        this.classConfigurationTemplates = response.data.data
        this.classConfigurationTemplates.forEach(template => {
          template['config'] = template['class_config']
          delete template['class_config']
        })
      })
  }
}
</script>

<style>

</style>
